import {useState, useEffect} from 'react';
import { initPage } from '../App';

const Page2 = () => {

  const [papelBaixoEnabled, setPapelBaixoEnabled] = useState(false);
  const papelBaixoText = (
    <span>
      Parabéns, você acaba de receber a mais recente tecnologia de integração nacional via ressonância. Em suas mãos está um mecanismo oficial do governo para garantir a harmonia, a obediência e a circulação de informações verídicas em todo o território de Planaltina.

      <br/>
      <br/>
      Os rádios da DURN ornamentam as casas, os becos e os postos de controle da nossa cidade, servindo como antenas vivas da verdade estatal. Cada chiado, cada estática, cada ruído é um lembrete de que o progresso pode ser contido, domado e revertido quando ameaça a ordem.

      <br/>
      <br/>
      A Diretoria de Segurança adverte:

      <br/>
      <br/>
      Modificações clandestinas em rádios são crime punível com o confisco do aparelho e recadastramento compulsório de sua família.

      <br/>
      <br/>
      Sintonizar frequências não autorizadas implica em ruído mental severo e isolamento comunitário.

      <br/>
      <br/>
      Distribuir fitas ou fragmentos de transmissões distorcidas é propaganda subversiva — e Planaltina não tolera subversão.

      <br/>
      <br/>
      Lembre-se: Os rádios que repousam nas prateleiras de suas casas são mais do que objetos — são símbolos da nossa união, faróis de disciplina e memórias do que fomos antes de nos tornarmos fortes outra vez.

      <br/>
      <br/>
      <br/><strong><h3 style={{opacity: "0.8"}}>Diretoria Unificada de Reconstrução Nacional</h3></strong>

    </span>
  )

  const [papelParedeEnabled, setPapelParedeEnabled] = useState(false);
  const papelParedeText = (
    <span>
      Essa residência foi fixada e garantida pelas ações de Diretoria Unificada de Reconstrução Nacional. Os direitos dos moradores estão garantidos perante a portaria número 160/12, de 13 de maio de 3006 P.M. Quaisquer deslizes legais podem resultar no desligamento dos moradores de sua devida residência governamental.
    </span>
  )

  const [radioEnabled, setRadioEnabled] = useState(false);
  const radioGif = (
    <img src='/aparato_gif3.gif' width={"50%"} height={"auto"} alt="Radio"></img>
  )

  useEffect(() => {
    initPage();
  }, [])

  return (
    <div className="page-container">
      <div style={{ width: '100%', height: '100%', position: 'relative' }}>
        <img 
          src="/SALA-2.png" 
          alt="Background" 
          className="background-image"
        />


        {/* Porta voltar */}
        <div 
          className="clickable-area seta-direita"
          style={{
            top: '20%',
            left: '91%',
            width: '9%',
            height: '50%',
            opacity: 0.0,
            background: 'red'
          }}
          onClick={() => window.location.href = '/1'}
        />

        {/* Rádio */}
        
        <div className='clickable-area radio'
          style={{
            top: "40%",
            left: "-2%",
            background: 'red',
            width: "30%",
            height: "57%",
            opacity: 0.0,
            clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)",
            transform: "rotate(3deg)"
          }}
          onClick={() => window.location.href =  "/radio"}
        >

        </div>

        {/* papel baixo */}
        <div 
          className="clickable-area"
          style={{
            top: '85%',
            left: '54%',
            width: '15%',
            height: '9%',
            opacity: 0.0,
            background: 'red'
          }}
          onClick={() => setPapelBaixoEnabled(!papelBaixoEnabled)}
        />

        {/* Area do papel */}
        {papelBaixoEnabled && (
          <div className="incensario-area"
            style={{
              background: "url('/papel-vertical-1.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "31ch",
              zIndex: 1000
            }}
          >
            <div className="close-button" onClick={() => setPapelBaixoEnabled(false)}
            style={{
                transform: "translate(-300%, 100%)"
            }}
            >X</div>
            <p style={{
              padding: "3rem",
              maxHeight:"90%",
              maxWidth: "26ch",
              overflow: "auto"
            }}>{papelBaixoText}</p>
            {/* <div className="submit-button" onClick={() => setPapelBaixoEnabled(false)}>Fechar</div> */}
          </div>
        )}

        {/* Parede */}
        <div 
          className="clickable-area parede"
          style={{
            top: '25%',
            left: '55%',
            width: '12.5%',
            height: '14%',
            opacity: 0.0,
            background: 'red'
          }}
          onClick={() => setPapelParedeEnabled(!papelParedeEnabled)}
        />

        {/* Area do papel */}
        {papelParedeEnabled && (
          <div className="modal-area"
            style={{
              background: "url('/papel-horizontal-1.png')",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "40ch"
            }}
          >
            <div className="close-button" onClick={() => setPapelParedeEnabled(false)}
              style={{
                  transform: "translate(-100%, 50%)"
              }}
            >X</div>
            <p
              style={{
                width: "35ch"
              }}
            >{papelParedeText}</p>
          </div>
        )}

        {radioEnabled && (
          <div className="modal-area">
            <div className="close-button" onClick={() => setRadioEnabled(false)}>X</div>
            <div className="modal-content" style={{background: "transparent"}}>
              {radioGif}
            </div>
          </div>
        )}



        {/* Porta 3 */}
        <div 
          className="clickable-area seta-esquerda"
          style={{
            top: '24%',
            left: '36%',
            width: '14%',
            height: '36%',
            opacity: 0.0,
            background: 'red',
            borderTopLeftRadius: '35%',
            borderTopRightRadius: '40%',
          }}
          onClick={() => window.location.href = '/3'}
        />

      </div>
    </div>
  );
};

export default Page2;
